import { api } from "@shared/api/client";
import type {
  CalidadControlModificacion,
  CalidadControlModificacionPayload,
} from "../../../types/control-modificaciones";
import type {
  CalidadDirectLikePayload,
  CalidadSuministradorHomologadoDirecto,
  CalidadSuministradorHomologadoGrupo,
  CalidadSuministradorHomologadoIndirecto,
  CalidadIndirectoPayload,
  CalidadSuministradoresHomologadosResponse,
} from "../types/suministradores-homologados";

export async function getCalidadSuministradoresHomologados() {
  const { data } = await api.get<CalidadSuministradoresHomologadosResponse>(
    "/certificaciones/iso-9001-14001/suministradores-homologados",
  );

  return data;
}

export async function createCalidadSuministradorIndirecto(
  payload: CalidadIndirectoPayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadSuministradorHomologadoIndirecto;
  }>("/certificaciones/iso-9001-14001/suministradores-homologados/indirectos", payload);

  return data.data;
}

export async function updateCalidadSuministradorIndirecto(
  id: number,
  payload: CalidadIndirectoPayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadSuministradorHomologadoIndirecto;
  }>(`/certificaciones/iso-9001-14001/suministradores-homologados/indirectos/${id}`, payload);

  return data.data;
}

export async function deleteCalidadSuministradorIndirecto(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/suministradores-homologados/indirectos/${id}`);
}

export async function createCalidadSuministradorDirecto(
  payload: CalidadDirectLikePayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadSuministradorHomologadoDirecto;
  }>("/certificaciones/iso-9001-14001/suministradores-homologados/directos", payload);

  return data.data;
}

export async function updateCalidadSuministradorDirecto(
  id: number,
  payload: CalidadDirectLikePayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadSuministradorHomologadoDirecto;
  }>(`/certificaciones/iso-9001-14001/suministradores-homologados/directos/${id}`, payload);

  return data.data;
}

export async function deleteCalidadSuministradorDirecto(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/suministradores-homologados/directos/${id}`);
}

export async function createCalidadSuministradorGrupo(
  payload: CalidadDirectLikePayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadSuministradorHomologadoGrupo;
  }>("/certificaciones/iso-9001-14001/suministradores-homologados/grupo", payload);

  return data.data;
}

export async function updateCalidadSuministradorGrupo(
  id: number,
  payload: CalidadDirectLikePayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadSuministradorHomologadoGrupo;
  }>(`/certificaciones/iso-9001-14001/suministradores-homologados/grupo/${id}`, payload);

  return data.data;
}

export async function deleteCalidadSuministradorGrupo(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/suministradores-homologados/grupo/${id}`);
}

export async function createCalidadSuministradoresControlModificacion(
  payload: CalidadControlModificacionPayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>("/certificaciones/iso-9001-14001/suministradores-homologados/control-modificaciones", payload);

  return data.data;
}

export async function updateCalidadSuministradoresControlModificacion(
  id: number,
  payload: CalidadControlModificacionPayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>(`/certificaciones/iso-9001-14001/suministradores-homologados/control-modificaciones/${id}`, payload);

  return data.data;
}

export async function deleteCalidadSuministradoresControlModificacion(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/suministradores-homologados/control-modificaciones/${id}`);
}
